import { useTranslation } from 'react-i18next';

const FeaturesSection = () => {
  const { t } = useTranslation();

  const items = [
    { icon: 'fa-lock', titleKey: 'whyScrooge.item1.title', descKey: 'whyScrooge.item1.description' },
    { icon: 'fa-shield-halved', titleKey: 'whyScrooge.item2.title', descKey: 'whyScrooge.item2.description' },
    { icon: 'fa-water', titleKey: 'whyScrooge.item3.title', descKey: 'whyScrooge.item3.description' },
    { icon: 'fa-hand-holding-dollar', titleKey: 'whyScrooge.item4.title', descKey: 'whyScrooge.item4.description' },
  ];

  return (
    <section id="why-scrooge" className="section-x why-scrooge">
      <div className="dot-grid dot-grid--subtle" />

      <div className="container">
        <div className="row">
          <div className="col-lg-9 mx-auto text-center mb-5">
            <div className="eyebrow eyebrow--center mb-3" data-aos="fade-up">
              <span>{t('whyScrooge.eyebrow')}</span>
            </div>
            <h2 className="section-heading" data-aos="fade-up">
              {t('whyScrooge.titleLead')}{' '}
              <span className="gold-text">{t('whyScrooge.titleHighlight')}</span>
            </h2>
            <p className="section-subheading" data-aos="fade-up" data-aos-delay="80">
              {t('whyScrooge.subtitle')}
            </p>
          </div>
        </div>

        <div className="row g-4">
          {items.map((item, i) => (
            <div key={item.titleKey} className="col-md-6" data-aos="fade-up" data-aos-delay={i * 80}>
              <div className="why-card">
                <div className="why-card__num mono">0{i + 1}</div>
                <div className="why-card__icon">
                  <i className={`fas ${item.icon}`} />
                </div>
                <h4 className="why-card__title">{t(item.titleKey)}</h4>
                <p className="why-card__desc">{t(item.descKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
